import axios from "axios";

export const state = {
    appointments: [],
    appointment_status: false,
    appo_edit_status: false,
    appointment_details: {},
    appointment_calendar: [],
    patient_appointments:[],
    appointmentsreport:[]

};

export const getters = {
    Appointments: state => state.appointments.data,
    AppointmentsReport: state => state.appointmentsreport.data,
    Appointment_status: state => state.appointment_status,
    AppoEditStatus: state => state.appo_edit_status,
    AppointmentDetails: state => state.appointment_details.data,
    AppointmentCalendar: state => state.appointment_calendar.data,
    PatientAppointments: state => state.patient_appointments.data,
};
export const mutations = {
    SET_APPOINTMENTS(state, newValue) {
        state.appointments = newValue
    },
    SET_APPOINTMENTSREPORT(state, newValue) {
        state.appointmentsreport = newValue
    },
    SET_PATIENT_APPOINTMENTS(state, newValue) {
        state.patient_appointments = newValue
    },
    SET_APPOINTMENT_STATUS(state, newValue) {
        state.appointment_status = newValue
    },
    SET_APPOINTMENT_DETAILS(state, newValue) {
        state.appointment_details = newValue
    },
    SET_APPOINTMENT_CALENDAR(state, newValue) {
        state.appointment_calendar = newValue
    },
    SET_APPOINTMENT_CALENDAR_TEMP(state) {
        state.appointment_calendar = []
    },
    SET_EDIT_APPOINTMENT_STATUS(state, newValue) {
        state.appo_edit_status = newValue
    },
    SET_APPOINTMENT_TEMPALTE(state) {
        state.appointment_details = {
            "data": {
                "id": "",
                "short": "",
                "diagnoses_id": null,
                "location": "",
                "date": "",
                "addedBy": "",
                "status": "",
                "rstatus": "",
                "dateCreated": "",
                "dateUpdated": "",
                "patient": null,
                "recent_appo": [],
                "doctor": null
            }
        }
    },
};

export const actions = {
    fetchAppointments({ commit, dispatch }) {
        axios.get('appointments').then(res => {
            commit('SET_APPOINTMENTS', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchAppointmentsReport({ commit, dispatch }) {
        axios.get('appointmentsget').then(res => {
            commit('SET_APPOINTMENTSREPORT', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchCalendarData({ commit, dispatch }, payload) {
        commit('SET_APPOINTMENT_CALENDAR_TEMP')
        axios.get(`appointments_calender/${payload}`).then(res => {
            commit('SET_APPOINTMENT_CALENDAR', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    editAppointment({ commit, dispatch }, payload) {
        commit('SET_EDIT_APPOINTMENT_STATUS', true)
        axios.put(`appointments/${payload.id}`, payload).then(res => {
            commit('SET_EDIT_APPOINTMENT_STATUS', false)
            commit('SET_APPOINTMENT_DETAILS', res.data)
            let message = { 'msg': "Appointment edited successfully" }
            dispatch('notification/success', message, { root: true })
            dispatch('fetchCalendarData', payload.id)
            dispatch('fetchAppointments')

        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            let message = { 'msg': "Error editing appointment" }
            dispatch('notification/error', message, { root: true })
        })
    },
    changeAppointmentStatus({ commit, dispatch }, payload) {
        commit('SET_EDIT_APPOINTMENT_STATUS', true)
        axios.put(`changeappostatus/${payload.id}`, payload).then(res => {
            commit('SET_EDIT_APPOINTMENT_STATUS', false)
            commit('SET_APPOINTMENT_DETAILS', res.data)
            let message = { 'msg': "Appointment updated successfully" }
            dispatch('notification/success', message, { root: true })
            dispatch('fetchCalendarData', payload.id)
            dispatch('fetchAppointments')

        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            let message = { 'msg': "Error editing appointment" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchAppointmentDetails({ commit, dispatch }, payload) {
        commit('SET_APPOINTMENT_STATUS', true)
        commit('SET_APPOINTMENT_TEMPALTE')
        axios.get(`appointments/${payload}`).then(res => {
            commit('SET_APPOINTMENT_STATUS', false)
            commit('SET_APPOINTMENT_DETAILS', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
        fetchPatientAppointments({ commit, dispatch }, patient_id) {
        commit('SET_APPOINTMENT_STATUS', true)
        axios.get(`patient_appointments/${patient_id}`).then(res => {
            commit('SET_APPOINTMENT_STATUS', false)
            commit('SET_PATIENT_APPOINTMENTS', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    saveAppointments({ dispatch, commit }, payload) {
        commit('SET_APPOINTMENT_STATUS', true)
        axios.post('appointments', payload).then(() => {
            commit('SET_APPOINTMENT_STATUS', false)
            let message = { 'msg': "Appointment set successfully" }
            dispatch('notification/success', message, { root: true })
            dispatch('fetchAppointments')
            dispatch('fetchPatientAppointments',payload.patient_id)
        }).catch((eror) => {
            commit('SET_APPOINTMENT_STATUS', false)
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            let message = { 'msg': "Error setting appointment" }
            dispatch('notification/error', message, { root: true })
        })
    },
    appointmentReminder({ dispatch, commit }, payload) {
        commit('SET_APPOINTMENT_STATUS', true)
        axios.post('reminder', payload).then(() => {
            commit('SET_APPOINTMENT_STATUS', false)
            let message = { 'msg': "Appointment reminder sent successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch((eror) => {
            commit('SET_APPOINTMENT_STATUS', false)
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            let message = { 'msg': "Error sending appointment reminder" }
            dispatch('notification/error', message, { root: true })
        })
    },
}